module.exports = "<div class=\"container-fluid mkt-hero p-0\">\n  <div class=\"mkt-hero__inner\">\n    <mkt-hero-carousel  (searchById)=\"triggerSearch($event)\" [marketingOffers]=\"marketingOffers\"></mkt-hero-carousel>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/hero/mkt-hero/mkt-hero.component.html
// module id = ../../../../../src/app/hero/mkt-hero/mkt-hero.component.html
// module chunks = main